import React, { useEffect, useState } from 'react';
import { message } from 'antd';

import ChooseTime from './components/chooseTime';
import RowTable from './components/rowTable';
import LineChart from './components/lineChart';
import PieChart from './components/pieChart';
import { merchantIndicator } from '@/services/chartData';
const MerchantData = () => {
  const [rowTableData, setRowTableData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [timeRadioValue, setTimeRadioValue] = useState('month');
  const [timeRangeValue, setTimeRangeValue] = useState(['', '']);
  const queryMerchantData = () => {
    let requestData = {};
    if (timeRadioValue === 'date') {
      requestData = {
        startDate: timeRangeValue[0],
        endDate: timeRangeValue[1],
      };
    } else {
      requestData = {
        quickQuery: timeRadioValue,
      };
    }
    merchantIndicator({
      requestData: requestData,
    }).then(({ code, msg, data }) => {
      if (code === '00000') {
        setDatas(data);
      } else {
        message.error(msg);
      }
    });
  };
  const setDatas = (data) => {
    setRowTableData([
      {
        title: '总商家数',
        value: data.coachTotal,
        isTailDivider: true,
      },
      {
        title: '免费注册',
        value: data.coachFree,
        isTailDivider: true,
      },
      {
        title: '充值保证金',
        value: data.coachMargin,
        isTailDivider: true,
      },
      {
        title: '有健身大人物权益',
        value: data.coachBigbang,
      },
    ]);
    setPieData([
      {
        title: '免费注册',
        value: Number(data.coachFree),
      },
      {
        title: '充值保证金',
        value: Number(data.coachMargin),
      },
      {
        title: '有健身大人物权益',
        value: Number(data.coachBigbang),
      },
    ]);
    let arr = [];
    arr = arr
      .concat(
        data.coachFreeTrend.map((i) => {
          return {
            ...i,
            category: '免费注册商家数趋势',
          };
        }),
      )
      .concat(
        data.coachMarginTrend.map((i) => {
          return {
            ...i,
            category: '充值保证金商家数趋势',
          };
        }),
      )
      .concat(
        data.coachBigbangTrend.map((i) => {
          return {
            ...i,
            category: '有健身大人物权益商家数趋势',
          };
        }),
      );
    setLineData(arr);
  };
  useEffect(() => {
    queryMerchantData();
  }, [timeRadioValue, timeRangeValue]);
  const handleTimeChange = (type, value) => {
    if (type === 'date' && value) {
      setTimeRangeValue(value);
    }
    setTimeRadioValue(type);
  };
  return (
    <div>
      <ChooseTime
        timeRadioValue={timeRadioValue}
        onTimeChange={handleTimeChange}
      />
      <RowTable rowTableData={rowTableData} title="商家构成" />
      <PieChart pieData={pieData} />
      <LineChart
        lineData={lineData}
        xField="abscissa"
        yField="ordinate"
        seriesField="category"
      />
    </div>
  );
};

export default MerchantData;
